import { useState, useCallback } from "react";

interface UseMessageSelectionReturn {
  selectedMessageIds: Set<string>;
  isSelectionMode: boolean;
  toggleMessageSelection: (id: string) => void;
  selectMessage: (id: string) => void;
  clearSelection: () => void;
  isSelected: (id: string) => boolean;
  selectAllVisible: (ids: string[]) => void;
}

export function useMessageSelection(): UseMessageSelectionReturn {
  const [selectedMessageIds, setSelectedMessageIds] = useState<Set<string>>(new Set());
  
  const isSelectionMode = selectedMessageIds.size > 0;

  const toggleMessageSelection = useCallback((id: string) => {
    setSelectedMessageIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  const selectMessage = useCallback((id: string) => {
    setSelectedMessageIds(new Set([id]));
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedMessageIds(new Set());
  }, []);

  const isSelected = useCallback(
    (id: string) => selectedMessageIds.has(id),
    [selectedMessageIds]
  );

  const selectAllVisible = useCallback((ids: string[]) => {
    setSelectedMessageIds(new Set(ids));
  }, []);

  return {
    selectedMessageIds,
    isSelectionMode,
    toggleMessageSelection,
    selectMessage,
    clearSelection,
    isSelected,
    selectAllVisible,
  };
}
